import { isNil, isEmpty } from 'lodash';

export const isEmptyOrNull = (value) => isNil(value) || isEmpty(value);